// extracted by mini-css-extract-plugin
export default {"container":"pN-z","dimension":"qN-z","dimensionLabels":"rN-z"};